export const ProjectsListConfig = {
    name            : 'Projects list',
    icon            : 'i5-projects-list',
    image           : 'projects-list2',
    iconSvg         : 'isvg-view-projects-list',
    url             : 'projects-list',
    description     : 'Multi purpose, customizable projects view with hierarchy support.',
    canBeInProject  : true,
}

export const PROJECTS_PROJECTS_LIST_CONFIG = {
    ...ProjectsListConfig,
    // key2: "newValue2",  // Replacing the value for key2
}